const { strToSI: expressionStrToSI } = require('../Expression')

module.exports = expressionStrToSI // This works exactly the same as for expressions.